import { v4 } from 'uuid';

// Environments
export enum ENVIRONMENTS_ENUM {
  DEV = 'development',
  TEST = 'test',
  PROD = 'production',
}

export const {
  NODE_ENV,
  REACT_APP_ENVIRONMENT,
  REACT_APP_FEATURE_BRANCH,
  REACT_APP_COMMIT_HASH,
  REACT_APP_VERSION,
} = process.env;

export const ENVIRONMENT = REACT_APP_ENVIRONMENT || NODE_ENV;
export const FEATURE_BRANCH = REACT_APP_FEATURE_BRANCH;
export const COMMIT_HASH = REACT_APP_COMMIT_HASH;
export const APP_VERSION = REACT_APP_VERSION;

export const KEY_CODES = {
  ESCAPE: 27,
  ENTER: 16,
};

export const MONTHLY_BASE_FEE = 30.00;
export const PRICE_PER_EMPLOYEE = 1.99;
export const IS_CHARITY_DISCOUNT_AMOUNT = 25.00;
export const BASE_SETUP_FEE = 50.00;
export const BANK_ACCOUNT_NAME_MAX_LENGTH = 80;
export const ADDITIONAL_COMMENTS_MAX_LENGTH = 400;

export const PLAN_IDS = {
  CALCULATE_AND_MAKE_PAYMENTS_AUTOMATICALLY: 'calculate-and-automate',
  CALCULATE_ONLY: 'calculate-only',
};

export const SMART_HR_ID = 'smart-hr';
export const HR_WE_DO_THIS_OURSELVES = 'We do this ourselves right now';
export const BASE_META_TITLE = 'My SmartPayroll SignUp';
export const PRIVACY_POLICY_URL = 'https://www.smartpayroll.co.nz/privacy/';
export const DD_AUTHORITY_TERMS_AND_CONDITIONS_URL = 'https://www.smartpayroll.co.nz/paperless-direct-debit-authority-terms-and-conditions/';
export const SMART_PAYROLL_HOME_URL = 'https://www.smartpayroll.co.nz';
export const OPTION_OTHER = 'Other';
export const OPTION_OTHER_PAYROLL_SOFTWARE = 'Other payroll software';
export const BANK_OTHER_ID = '98e9ee30-a3c4-ea11-a812-000d3a6a398b';
export const BANK_ASB = 'ASB';
export const BANK_ANZ = 'ANZ';

// Create a guid on startup
// @TODO do we want to check local storage for one if we've already generated one for this user?
export const uniqueGUID = v4();
export const leadSubmitGUID = v4();
export const TO_DEACTIVATE_STRING = '[TO DEACTIVATE]';
